(function($) {
	$(function() {

		// $('#theme-header').sticky({zIndex: $('#theme-header').css('z-index') });
		$(window).on('scroll', function () {
			let $header    = $('#theme-header__outer-container');
			let scrollTop  = $(window).scrollTop();
			let stickAfter = 200;

			if ( $header.hasClass('theme-header--is-pre-sticky') ) {
				$header.css( 'top', $(window).scrollTop() );

				if ( scrollTop > stickAfter ) {
					$header.addClass('theme-header--is-compact');
					$header.one('transitionend', function (e) {
						if (scrollTop > stickAfter) {
							$header.removeClass('theme-header--is-pre-sticky')
								.addClass('theme-header--is-stuck')
								.css( 'top', '' );
						}
					});

					// setTimeout(function () {
					// 	if (scrollTop > stickAfter) {
					// 		$header.removeClass('theme-header--is-pre-sticky')
					// 			.addClass('theme-header--is-stuck')
					// 			.css( 'top', 0 );
					// 	}
					// }, 400); // Timing must match $compact-transition in _settings.scss
				}
			} else {
				if ( scrollTop < stickAfter ) {
					$header
						.removeClass('theme-header--is-stuck')
						.removeClass('theme-header--is-compact')
						.addClass('theme-header--is-pre-sticky')
						.css( 'top', $(window).scrollTop() );
				}
			}

		});

	}); // DOM ready
})(jQuery);
